module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GH-582defb62bf9f0b49e3f3981f0fc3713.png";